module.exports = __webpack_public_path__ + "static/media/folder-check.81375778.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/folder-check.svg
// module id = 2920
// module chunks = 7